<form (submit)="submit($event)" [formGroup]="appVersionForm">
    <div class="pb-6 flex flex-col gap-7">
      <div class="flex flex-col gap-4">
        <label for="version" class="font-bold">Version</label>
        <input id="version" pInputText type="text" placeholder="Version" />
      </div>

      <div class="flex flex-col gap-4">
        <label for="changelog" class="font-bold">Änderungsbeschreibung (Changelog)</label>
        <p-editor
          id="changelog"
          placeholder="Was hat sich seit der letzten Version verändert?"
          formControlName="changelog"
          [style]="{ height: '150px' }"
        />
      </div>
    </div>
  <div class="w-full flex gap-2 justify-end">
    <p-button (onClick)="close()" [rounded]="true" [outlined]="true">Abrechen</p-button>
    <p-button [rounded]="true" type="submit">Erstellen</p-button>
  </div>
</form>
